import { gsap } from 'gsap';
import SplitType from 'split-type';

export default function () {
  let isPreaderDone = false;

  document.addEventListener('preloaderDone', () => {
    isPreaderDone = true;
  });

  function animateText() {
    if (document.querySelector('[data-page-error]')) {
      const pageError = document.querySelector('[data-page-error]');
      const splitTextErrorDescription = pageError.querySelector('[data-split-text-error-description]');
      const textError = pageError.querySelector('[data-split-text-error]');
      if (splitTextErrorDescription) {
        // eslint-disable-next-line no-new
        new SplitType(splitTextErrorDescription);
        if (isPreaderDone) {
          gsap.to(splitTextErrorDescription.querySelectorAll('.char'), {
            opacity: 1,
            y: 0,
            stagger: 0.05,
            delay: 0.2,
            duration: 0.1,
          });
          gsap.to(textError, {
            y: 0,
          });
        } else {
          gsap.set(splitTextErrorDescription.querySelectorAll('.char'), { opacity: 0 });
          gsap.set(textError, { y: '500%' });
          document.addEventListener('preloaderDone', () => {
            gsap.to(splitTextErrorDescription.querySelectorAll('.char'), {
              opacity: 1,
              y: 0,
              stagger: 0.05,
              delay: 0.2,
              duration: 0.1,
            });
            gsap.to(textError, {
              y: 0,
            });
          });
        }
      }
    }
  }

  function handleResize() {
    animateText();
  }

  animateText();

  window.addEventListener('resize', handleResize);
}
